import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
// import Social from '../section-components/social';
import SocialsNetwork from '../section-components/SocialsNetwork';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const SecondaryHeader = (props) => {

    const publicUrl = process.env.PUBLIC_URL + "/";
    const CustomClass = props.CustomClass ? props.CustomClass : "";
    let imgattr = "logo";
    let anchor = "#";

    // const { subdivisions } = useDataContext();

    const $ = window.$;
    const $body = $('body');

    useEffect(() => {

        (function () {
            const $ltn__utilizeToggle = $('.ltn__utilize-toggle'),
                $ltn__utilize = $('.ltn__utilize'),
                $ltn__utilizeOverlay = $('.ltn__utilize-overlay'),
                $mobileMenuToggle = $('.mobile-menu-toggle');
            $ltn__utilizeToggle.on('click', function (e) {

                e.preventDefault();
                const $this = $(this),
                    $target = $this.attr('href');
                $body.addClass('ltn__utilize-open');
                $($target).addClass('ltn__utilize-open');
                $ltn__utilizeOverlay.fadeIn();
                if ($this.parent().hasClass('mobile-menu-toggle')) {
                    $this.addClass('close');
                }
            });
            $('.ltn__utilize-close, .ltn__utilize-overlay').on('click', function (e) {
                e.preventDefault();
                $body.removeClass('ltn__utilize-open');
                $ltn__utilize.removeClass('ltn__utilize-open');
                $ltn__utilizeOverlay.fadeOut();
                $mobileMenuToggle.find('a').removeClass('close');
            });
        })();
    }, [$, $body]);

    /**
     * 
     * @param {*} el 
     */
    const toggleSubMenu = (el) => {
        var $this = $(el);

        if ($this.siblings('ul:visible').length) {
            $this.parent('li').removeClass('active');
            $this.siblings('ul').slideUp();
            $this.parent('li').find('li').removeClass('active');
            $this.parent('li').find('ul:visible').slideUp();
        } else {
            $this.parent('li').addClass('active');
            $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
            $this.closest('li').siblings('li').find('ul:visible').slideUp();
            $this.siblings('ul').addClass('.show').slideDown();
        }
    };

    return (
        <div>
            <header className={`ltn__header-area ltn__header-5 ltn__header-transparent--- gradient-color-4--- ${CustomClass}`}>
                <div className="ltn__header-top-area section-bg-6 top-area-color-white---">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">
                                <div className="ltn__top-bar-menu">
                                    <ul>
                                        <li><a href="mailto:info@webmail.com?Subject=Flower%20greetings%20to%20you"><i className="icon-mail" /> contact@terganeteranga.com</a></li>
                                        <li><a href="locations.html"><i className="icon-placeholder" /> VDN, Lot 67, Bande Verte Échangeur</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="top-bar-right text-end">
                                    <div className="ltn__top-bar-menu">
                                        <ul>
                                            <li className="d-none">
                                                {/* ltn__language-menu */}
                                                <div className="ltn__drop-menu ltn__currency-menu ltn__language-menu">
                                                    <ul>
                                                        <li><a href="#" className="dropdown-toggle"><span className="active-currency">English</span></a>
                                                            <ul>
                                                                <li><Link to="#">Arabic</Link></li>
                                                                <li><Link to="#">Bengali</Link></li>
                                                                <li><Link to="#">Chinese</Link></li>
                                                                <li><Link to="#">English</Link></li>
                                                                <li><Link to="#">French</Link></li>
                                                                <li><Link to="#">Hindi</Link></li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <SocialsNetwork />
                                            </li>
                                            {/* <li>
                                                header-top-btn
                                                <div className="header-top-btn">
                                                    <Link to="/add-listing">Add Listing</Link>
                                                </div>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="site-logo-wrap">
                                    <div className="site-logo go-top">
                                        <Link to="/">
                                            <img
                                                src={`${publicUrl}logo.png`}
                                                width="130"
                                                alt="Logo"
                                            />
                                        </Link>
                                    </div>
                                    <div className="get-support clearfix d-none">
                                        <div className="get-support-icon">
                                            <i className="icon-call" />
                                        </div>
                                        <div className="get-support-info">
                                            <h6>Get Support</h6>
                                            <h4><a href="tel:+123456789">123-456-789-10</a></h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-auto header-menu-column menu-color-white---">
                                <div className="header-menu d-none d-xl-block">
                                    <nav>
                                        <div className="ltn__main-menu go-top">
                                            <ul>
                                                <li>
                                                    <Link to="/">Accueil</Link>
                                                </li>
                                                <li className="menu-icon">
                                                    <button type="button">Biens immobiliers</button>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            {/* <Link to="/appartements">Appartements</Link> */}
                                                            <button type="button">Appartements</button>
                                                            <ul>
                                                                <li>
                                                                    <Link to="/appartements/reel">Réel</Link>
                                                                </li>
                                                                <li>
                                                                    <Link to="/appartements/vefa">Vefa</Link>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <Link to="/maisons">Maisons</Link>
                                                        </li>
                                                        <li>
                                                            {/* <Link to="/terrains">Terrains</Link> */}
                                                            <button type="button">Terrains</button>
                                                            <ul>
                                                                <li>
                                                                    <Link to="/terrains/lotissements">Lotissements</Link>
                                                                </li>
                                                                <li>
                                                                    <Link to="/terrains/parcelles-non-loties">Parcelles non loties</Link>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li className="menu-icon">
                                                    <button type="button">TerganeTeranga</button>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            <Link to="/terganeteranga">Qui sommes-nous ?</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/nos-offres">Nos offres</Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/accompagnement">Accompagnement</Link>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <Link to="/contact">Contact</Link>
                                                </li>
                                                {/* <li className="special-link">
                                                    <button
                                                        class="btn btn-effect-1 btn-search"
                                                        type="button"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#searchPanelRight"
                                                        aria-controls="searchPanelRight"
                                                    >
                                                        <i className="flaticon-loupe" />
                                                    </button>
                                                </li> */}
                                                {/* <li className="special-link">
                                                    <Link to="/localisation-des-biens-immobiliers">Localiser nos biens</Link>
                                                </li> */}
                                            </ul>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                            <div className="col ltn__header-options ltn__header-options-2 mb-sm-20">
                                {/* header-search-1 */}
                                <div className="header-search-wrap">
                                    <div className="header-search-1">
                                        {/* <div className="search-icon">
                                            <i className="icon-search for-search-show" />
                                            <i className="icon-cancel  for-search-close" />
                                        </div>
                                    </div> */}
                                        <button
                                            className="btn-search ltn__utilize-close search-icon bg-transparent"
                                            type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#searchPanelRight"
                                            aria-controls="searchPanelRight"
                                        >
                                            {/* <i className="flaticon-loupe" /> */}
                                            <i className="icon-search for-search-show" />
                                            <i className="icon-cancel  for-search-close" />
                                            {/* <span>Rechercher un bien</span> */}
                                        </button>
                                    </div>
                                </div>
                                {/* user-menu */}
                                <div className="ltn__drop-menu user-menu">
                                    <ul>
                                        <li>
                                            <Link to="#"><i className="icon-user" /></Link>
                                            {/* <ul className="go-top">
                                                <li><Link to="/login">Sign in</Link></li>
                                                <li><Link to="/register">Register</Link></li>
                                                <li><Link to="/my-account">Mon compte</Link></li>
                                                <li><Link to="#">Sign in</Link></li>
                                                <li><Link to="#">Register</Link></li>
                                                <li><Link to="#">Mon compte</Link></li>
                                            </ul> */}
                                        </li>
                                    </ul>
                                </div>
                                {/* mini-cart */}
                                {/* <div className="mini-cart-icon">
                                    <a href="#ltn__utilize-cart-menu" className="ltn__utilize-toggle">
                                        <i className="icon-shopping-cart"></i>
                                        <sup>2</sup>
                                    </a>
                                </div> */}
                                {/* mini-cart */}
                                <div className="locate-your-real-estate-button-wrapper">
                                    {/* <a href="#ltn__utilize-cart-menu" className="ltn__utilize-toggle">
                                        <i className="icon-shopping-cart"></i>
                                        <sup>2</sup>
                                    </a> */}
                                        <Link to="/localisation-des-biens-immobiliers">Localiser nos biens</Link>
                                </div>
                                {/* Mobile Menu Button */}
                                <div className="mobile-menu-toggle d-xl-none">
                                    <a href="#ltn__utilize-mobile-menu" className="ltn__utilize-toggle">
                                        <svg viewBox="0 0 800 600">
                                            <path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top" />
                                            <path d="M300,320 L540,320" id="middle" />
                                            <path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) " />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div id="ltn__utilize-mobile-menu" className="ltn__utilize ltn__utilize-mobile-menu">
                <div className="ltn__utilize-menu-inner ltn__scrollbar">
                    <div className="ltn__utilize-menu-head">
                        <div className="site-logo">
                            <Link to="/">
                                <img
                                    src={`${publicUrl}logo.png`}
                                    width="130"
                                    alt="Logo"
                                />
                            </Link>
                        </div>
                        <button className="ltn__utilize-close">×</button>
                    </div>
                    {/* <div className="ltn__utilize-menu-search-form">
                        <form action={"#"}>
                            <input type="text" placeholder="Search..." />
                            <button><i className="fas fa-search" /></button>
                        </form>
                    </div> */}
                    <div className="ltn__utilize-menu">
                        <ul>
                            <li>
                                <Link to="/">Accueil</Link>
                            </li>
                            <li>
                                <span className="menu-expand" onClick={(e) => {toggleSubMenu(e.currentTarget)}}></span>
                                <button type="button" onClick={(e) => {toggleSubMenu(e.currentTarget)}}>Biens immobiliers</button>
                                <ul className="sub-menu">
                                    <li>
                                        <span className="menu-expand" onClick={(e) => {toggleSubMenu(e.currentTarget)}}></span>
                                        <button type="button" onClick={(e) => {toggleSubMenu(e.currentTarget)}}>Appartements</button>
                                        <ul className="sub-menu">
                                            <li>
                                                <Link to="/appartements/reel">Réel</Link>
                                            </li>
                                            <li>
                                                <Link to="/appartements/vefa">Vefa</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link to="/maisons">Maisons</Link>
                                    </li>
                                    <li>
                                        <span className="menu-expand" onClick={(e) => {toggleSubMenu(e.currentTarget)}}></span>
                                        <button type="button" onClick={(e) => {toggleSubMenu(e.currentTarget)}}>Terrains</button>
                                        <ul className="sub-menu">
                                            <li>
                                                <Link to="/terrains/lotissements">Lotissements</Link>
                                            </li>
                                            <li>
                                                <Link to="/terrains/parcelles-non-loties">Parcelles non loties</Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <span className="menu-expand" onClick={(e) => {toggleSubMenu(e.currentTarget)}}></span>
                                <button type="button" onClick={(e) => {toggleSubMenu(e.currentTarget)}}>TerganeTeranga</button>
                                <ul className="sub-menu">
                                    <li>
                                        <Link to="/terganeteranga">Qui sommes-nous ?</Link>
                                    </li>
                                    <li>
                                        <Link to="/nos-offres">Nos offres</Link>
                                    </li>
                                    <li>
                                        <Link to="/accompagnement">Accompagnement</Link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <Link to="/contact">Contact</Link>
                            </li>
                        </ul>
                    </div>
                    {/* <div className="ltn__utilize-buttons ltn__utilize-buttons-2">
                        <ul> */}
                            {/* <li>
                                <Link to="/my-account" title="Mon compte">
                                    <span className="utilize-btn-icon">
                                        <i className="far fa-user" />
                                    </span>
                                    Mon compte
                                </Link>
                            </li> */}
                            {/* <li>
                                <Link to="/wishlist" title="Wishlist">
                                    <span className="utilize-btn-icon">
                                        <i className="far fa-heart" />
                                        <sup>3</sup>
                                    </span>
                                    Wishlist
                                </Link>
                            </li>
                            <li>
                                <Link to="/cart" title="Shoping Cart">
                                    <span className="utilize-btn-icon">
                                        <i className="fas fa-shopping-cart" />
                                        <sup>5</sup>
                                    </span>
                                    Shoping Cart
                                </Link>
                            </li> */}
                            {/* <li> */}
                                {/* header-search-1 */}
                                {/* <div className="header-search-wrap">
                                    <div className="header-search-1"> */}
                                        {/* <div className="search-icon">
                                            <i className="icon-search for-search-show" />
                                            <i className="icon-cancel  for-search-close" />
                                        </div>
                                    </div> */}
                                        {/* <button
                                            className="btn-search ltn__utilize-close search-icon bg-transparent"
                                            type="button"
                                            data-bs-toggle="offcanvas"
                                            data-bs-target="#searchPanelRight"
                                            aria-controls="searchPanelRight"
                                        >
                                            <i className="flaticon-loupe" /> */}
                                            {/* <i className="icon-search for-search-show" /> */}
                                            {/* <i className="icon-cancel  for-search-close" /> */}
                                            {/* <span>Rechercher un bien</span> */}
                                        {/* </button>
                                    </div>
                                </div>
                            </li> */}
                            {/* <li>
                                <div className="locate-your-real-estate-button-wrapper special-link p-0 ms-0">
                                    <Link to="/localisation-des-biens-immobiliers">Localiser nos biens</Link>
                                </div>
                            </li> */}
                        {/* </ul>
                    </div> */}
                    <div className="ltn__social-media-2">
                        <ul>
                            <li><a href="#" title="Facebook"><i className="fab fa-facebook-f" /></a></li>
                            <li><a href="#" title="Twitter"><i className="fab fa-twitter" /></a></li>
                            <li><a href="#" title="Linkedin"><i className="fab fa-linkedin" /></a></li>
                            <li><a href="#" title="Instagram"><i className="fab fa-instagram" /></a></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Utilize Cart Menu Start */}
            <div id="ltn__utilize-cart-menu" className="ltn__utilize ltn__utilize-cart-menu">
                <div className="ltn__utilize-menu-inner ltn__scrollbar">
                    <div className="ltn__utilize-menu-head">
                        <span className="ltn__utilize-menu-title">Cart</span>
                        <button className="ltn__utilize-close">×</button>
                    </div>
                    <div className="mini-cart-product-area ltn__scrollbar">
                        <div className="mini-cart-item clearfix">
                            <div className="mini-cart-img go-top">
                                <Link to="/product-details"><img src={publicUrl + "assets/img/product/1.png"} alt="Image" /></Link>
                                <span className="mini-cart-item-delete"><i className="icon-cancel" /></span>
                            </div>
                            <div className="mini-cart-info go-top">
                                <h6><Link to="/product-details">Wheel Bearing Retainer</Link></h6>
                                <span className="mini-cart-quantity">1 x $65.00</span>
                            </div>
                        </div>
                        <div className="mini-cart-item clearfix">
                            <div className="mini-cart-img go-top">
                                <Link to="/product-details"><img src={publicUrl + "assets/img/product/2.png"} alt="Image" /></Link>
                                <span className="mini-cart-item-delete"><i className="icon-cancel" /></span>
                            </div>
                            <div className="mini-cart-info go-top">
                                <h6><Link to="/product-details">Brake Conversion Kit</Link></h6>
                                <span className="mini-cart-quantity">1 x $85.00</span>
                            </div>
                        </div>
                        <div className="mini-cart-item clearfix">
                            <div className="mini-cart-img go-top">
                                <Link to="/product-details"><img src={publicUrl + "assets/img/product/3.png"} alt="Image" /></Link>
                                <span className="mini-cart-item-delete"><i className="icon-cancel" /></span>
                            </div>
                            <div className="mini-cart-info go-top">
                                <h6><Link to="/product-details">OE Replica Wheels</Link></h6>
                                <span className="mini-cart-quantity">1 x $92.00</span>
                            </div>
                        </div>
                        <div className="mini-cart-item clearfix">
                            <div className="mini-cart-img go-top">
                                <Link to="/product-details"><img src={publicUrl + "assets/img/product/4.png"} alt="Image" /></Link>
                                <span className="mini-cart-item-delete"><i className="icon-cancel" /></span>
                            </div>
                            <div className="mini-cart-info go-top">
                                <h6><Link to="/product-details">Shock Mount Insulator</Link></h6>
                                <span className="mini-cart-quantity">1 x $68.00</span>
                            </div>
                        </div>
                    </div>
                    <div className="mini-cart-footer">
                        <div className="mini-cart-sub-total">
                            <h5>Subtotal: <span>$310.00</span></h5>
                        </div>
                        <div className="btn-wrapper go-top">
                            <Link to="/cart" className="theme-btn-1 btn btn-effect-1">View Cart</Link>
                            <Link to="/cart" className="theme-btn-2 btn btn-effect-2">Checkout</Link>
                        </div>
                        <p>Free Shipping on All Orders Over $100!</p>
                    </div>
                </div>
            </div>
            {/* Utilize Cart Menu End */}

        </div>
    );
};

export default SecondaryHeader;
